/**
 *
 * AddCollaboratorsModal
 *
 */

import React from "react"
import { Table, Input } from "antd"
import { get, filter, map, flatMap } from "lodash"
import ModalCustom from "../ModalCustom"
import { columns } from "./columns"
import "./index.less"
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable"

/* eslint-disable react/prefer-stateless-function */
class AddCollaboratorsModal extends React.Component {
  state = {
    collaboratorsSelected: [],
    searchCollaborators: "",
  }

  searchCollaboratorsFunc = () => {
    const { searchCollaborators } = this.state
    const { survey } = this.props
    const listRecipients = get(this.props, "listRecipients", [])

    const onlyLeaders = filter(listRecipients, (item) => !item.employee_boss)

  /*   if (survey.id_survey_type === 2) {
      const onlyWithLeaders = filter(
        listRecipients,
        (item) => item.employee_boss
      )

      return onlyWithLeaders
    } */

    if (searchCollaborators) {
      return listRecipients.filter(
        (item) =>
          item.employee_name
            ?.toLowerCase()
            .includes(searchCollaborators.toLocaleLowerCase()) ||
          item.division_name
            ?.toLowerCase()
            .includes(searchCollaborators.toLocaleLowerCase())
      )
    }

    return listRecipients
  }

  render() {
    const { collaboratorsSelected } = this.state
    const { measureInfo } = this.props
    const isLeadership = get(this.props, "survey.id_survey_type", 1) || 1
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ collaboratorsSelected: selectedRowKeys })
      },
      onSelect: (record, selected, selectedRows) => {},
      selectedRowKeys: this.state.collaboratorsSelected,
    }

    return (
      <ModalCustom
        disabledButton={!collaboratorsSelected.length}
        width={isLeadership === 1 ? 720 : 860}
        textButton="Agregar"
        title="Agregar destinatarios"
        showFooter
        textAlign="left"
        {...this.props}
        onOk={() => {
          const params = {
            id_survey_type: get(measureInfo, "id_survey_type", 1),
            idMeasure: this.props.idMeasure,
            params: { id_employee: this.state.collaboratorsSelected },
          }

          this.props.postRecipientsWatcher(params)
          this.setState({ collaboratorsSelected: [] })
          this.props.setStateFrom("modalAddCollaborators", false)
        }}
        onCancel={() => {
          this.props.setStateFrom("modalAddCollaborators", false)
          this.setState({
            collaboratorsSelected: [],
            searchCollaborators: "",
          })
        }}>
        <div className="add-collaborators-modal-header">
          <p>Selecciona los destinatarios que deseas agregar a la medición:</p>
          <Input
            className="add-collaborators-modal-header-input"
            allowClear
            placeholder="Buscar..."
            value={this.state.searchCollaborators}
            onChange={(e) =>
              this.setState({ searchCollaborators: e.target.value })
            }
          />
        </div>
        <Table
          scroll={{ y: 280 }}
          rowSelection={rowSelection}
          rowKey={(record) => record.id_employee}
          dataSource={this.searchCollaboratorsFunc()}
          columns={columns(isLeadership)}
          className="tableCollaborator add-collaborators-modal-table"
        />
      </ModalCustom>
    )
  }
}

AddCollaboratorsModal.propTypes = {}

export default AddCollaboratorsModal
